(function(){
if(window.__retailModelsInit)return;
window.__retailModelsInit=true;

const CDN="https://cdn.sharkguitars.com/retail-models";
const DATA=(window.RETAIL_DATA||[]).slice().sort((a,b)=>(a.collection+a.name).localeCompare(b.collection+b.name));
const ICONS=window.RETAIL_ICONS||{};
const icon=name=>{const ic=ICONS[name];return ic?`<svg viewBox="${ic.vb}">${ic.d.map(d=>`<path d="${d}"/>`).join("")}</svg>`:""};
const ANGLES=[];for(let a=0;a<360;a+=15)ANGLES.push(a);
const FRONT=ANGLES.indexOf(90);
const framePath=(t,a)=>`${CDN}/frames/${t}/${String(a).padStart(3,'0')}.webp`;
const $=s=>document.querySelector(s);
let fColl="All",fSer="All",fQ="";
const getBody=d=>d.body.shape||"";
const getHs=d=>(d.neck.headstock_type||"").replace("(less)","");
const getScale=d=>{const m=(d.neck.scale_length||"").match(/[\d.]+"/);return m?m[0]:""};
const getFrets=d=>{const m=(d.neck.fret||"").match(/^\d+/);return m?m[0]:""};
const drops=[
  {key:"body",label:"Body",get:getBody},
  {key:"headstock",label:"Headstock",get:getHs},
  {key:"scale",label:"Scale",get:getScale},
  {key:"frets",label:"Frets",get:getFrets,suffix:" fr"},
];
const fDrop={body:"",headstock:"",scale:"",frets:""};

const colls=["All",...[...new Set(DATA.map(d=>d.collection))].sort()];
$("#rmCollFilter").innerHTML=colls.map(c=>`<button class="rm-pill${c==="All"?" on":""}" data-c="${c}">${c}</button>`).join("");
$("#rmSerFilter").innerHTML=["All","Prime","Supreme"].map(s=>`<button class="rm-pill${s==="All"?" on":""}" data-s="${s}">${s}</button>`).join("");
$("#rmDropFilters").innerHTML=drops.map(dr=>{
  const vals=[...new Set(DATA.map(dr.get).filter(Boolean))].sort();
  return `<select data-f="${dr.key}"><option value="">${dr.label}: All</option>`+
    vals.map(v=>`<option value="${v}">${dr.label}: ${v}${dr.suffix||""}</option>`).join("")+`</select>`;
}).join("");
$("#rmCollFilter").onclick=e=>{const b=e.target.closest(".rm-pill");if(!b)return;fColl=b.dataset.c;[...$("#rmCollFilter").children].forEach(x=>x.classList.toggle("on",x===b));render()};
$("#rmSerFilter").onclick=e=>{const b=e.target.closest(".rm-pill");if(!b)return;fSer=b.dataset.s;[...$("#rmSerFilter").children].forEach(x=>x.classList.toggle("on",x===b));render()};
$("#rmDropFilters").onchange=e=>{const s=e.target;fDrop[s.dataset.f]=s.value;s.classList.toggle("on",!!s.value);render()};
$("#rmQ").oninput=e=>{fQ=e.target.value.toLowerCase().trim();render()};

const blob=d=>JSON.stringify(d).toLowerCase();
function match(d){
  if(fColl!=="All"&&d.collection!==fColl)return false;
  if(fSer!=="All"&&d.series!==fSer)return false;
  for(const dr of drops){if(fDrop[dr.key]&&dr.get(d)!==fDrop[dr.key])return false;}
  if(fQ&&!blob(d).includes(fQ))return false;
  return true;
}

function fundamentals(d){
  const n=d.neck,b=d.body;
  const scale=(n.scale_length||"").match(/[\d.]+"/);
  const frets=(n.fret||"").match(/^\d+/);
  const kind=b.color_kind==="Solid"?"Solid":"Stained";
  const surf=(b.body_finish||"").replace("High Gloss","Gloss");
  const finish=(kind+" "+surf).trim();
  const hs=(n.headstock_type||"").replace("(less)","");
  return [["Body",b.shape],["Headstock",hs],["Profile",n.profile_label],
          ["Finish",finish],["Scale",scale?scale[0]:n.scale_length],["Frets",frets?frets[0]:n.fret]]
   .filter(x=>x[1]).map(x=>`<div><span class="rm-k">${x[0]}</span><span class="rm-v">${x[1]}</span></div>`).join("");
}
function render(){
  const list=DATA.filter(match);
  const g=$("#rmGrid");
  if(!list.length){g.innerHTML=`<div class="rm-empty">No models match your filters.</div>`;return}
  g.innerHTML=list.map((d,i)=>`
    <article class="rm-card" data-id="${d.id}" style="animation-delay:${Math.min(i,12)*40}ms">
      <div class="rm-shot"><img loading="lazy" src="${framePath(d.token,90)}" alt="${d.name}"></div>
      <div class="rm-info">
        <div class="rm-meta">
          <span class="rm-coll">${icon(d.collection)}<span>${d.collection}</span></span>
          <span class="rm-ser ${d.series.toLowerCase()}">${d.series}</span>
        </div>
        <h3><span class="rm-px">${d.prefix} - </span><span class="rm-nm">${d.name}</span></h3>
        <div class="rm-fund">${fundamentals(d)}</div>
      </div>
    </article>`).join("");
  requestAnimationFrame(()=>g.querySelectorAll(".rm-card").forEach(c=>c.classList.add("in")));
}
$("#rmGrid").onclick=e=>{const c=e.target.closest(".rm-card");if(c)openModal(c.dataset.id)};

function rowsBlock(pairs){
  const r=pairs.filter(p=>p[1]&&String(p[1]).trim()&&p[1]!=="None");
  if(!r.length)return"";
  return `<div class="rm-rows">`+r.map(p=>`<div class="rm-row"><div class="rm-k">${p[0]}</div><div class="rm-v">${p[1]}</div></div>`).join("")+`</div>`;
}
function sectionG(title,groups){
  const blocks=groups.map(rowsBlock).filter(Boolean);
  if(!blocks.length)return"";
  return `<div class="rm-sect"><div class="rm-hd"><h5>${title}</h5><span class="rm-ln"></span></div><div class="rm-rowgroup">${blocks.join("")}</div></div>`;
}

function specSections(d){
  const n=d.neck,b=d.body,p=d.pickups,fx=d.fx;let h="";
  const lacquerBody=b.color_kind==="Solid";
  const bodyColor=lacquerBody?`Solid Lacquer — ${b.solid_color}`:b.back_stain;
  h+=sectionG("Body",[
    [["Finish",b.body_finish],["Type",b.shape],["Contour",b.contour]],
    [["Body Wood",b.body_wood],[lacquerBody?"Lacquer Colour":"Body Stain",bodyColor]],
    (b.top_wood&&b.top_wood!=="None")?[["Top Wood",b.top_wood],["Top Stain",b.top_stain]]:[] ]);

  const stained=(n.neck_finish_type||"").toLowerCase().includes("stain");
  const neckCol=stained?n.neck_stain:n.neck_color;
  h+=sectionG("Neck & Fretboard",[
    [["Finish",(n.neck_finish||"")+(n.neck_finish_type?` · ${stained?"Stained":"Lacquer"}`:"")],
     ["Profile",n.profile_label],["Scale Length",n.scale_length],["Frets",n.fret],
     ["Nut Width",n.nut_width],["Fretboard Radius",n.radius_display],
     ["Thickness @0",n.thickness_0],["Thickness @12",n.thickness_12]],
    [["Neck Wood",n.neck_wood],[stained?"Neck Stain":"Neck Colour (Lacquer)",neckCol]],
    [["Fretboard Wood",n.fretboard_wood],
     ["Fretboard Stain",(n.fretboard_stain&&n.fretboard_stain!=="None")?n.fretboard_stain:""]] ]);

  const veneer=n.headstock_top_wood&&n.headstock_top_wood!=="None";
  h+=sectionG("Headstock",[ veneer
    ? [["Type",n.headstock_type],["Veneer Wood",n.headstock_top_wood],["Veneer Stain",n.headstock_top_wood_stain]]
    : [["Type",n.headstock_type],["Top","One-piece with neck (no veneer)"],["Matches",`Neck wood & finish — ${neckCol||n.neck_wood}`]] ]);

  h+=sectionG("Inlays & Cosmetics",[
    [["Inlay Design",n.inlay_design],["Inlay Material",n.inlay_material],
     ["Binding",n.binding],["Side Dots",n.side_dots],["Shark Logo",n.shark_logo]] ]);

  h+=sectionG("Anodization Colours",[
    [["Bridge — Main",d.bridge.main],["Bridge — Secondary",d.bridge.secondary],["Rollers",d.bridge.rollers],
     ["Knobs & Arm Cap",d.bridge.knobs_arm_cap],["Tremolo Arm",d.bridge.arm]],
    [["Nut — Main",d.nut.main],["Nut — Secondary",d.nut.secondary]],
    [["Pickup Frames",b.pickup_frame]] ]);

  const hasFx=fx["Main FX Card Slot 1"]||fx["Main FX Card Slot 2"]||fx["Mini FX Card"];
  h+=sectionG("Electronics & FX",[
    [["Module",d.electronics.module],["Control Knobs",d.electronics.knobs],
     ["Switches",d.electronics.switches],["Buttons",d.electronics.buttons]],
    hasFx?[["FX — Main 1",fx["Main FX Card Slot 1"]],["FX — Main 2",fx["Main FX Card Slot 2"]],["FX — Mini",fx["Mini FX Card"]]]:[] ]);

  h+=sectionG("Pickups",[
    [["Neck",p.neck.model+(p.neck.cover?` — ${p.neck.cover} cover`:"")],
     ["Bridge",p.bridge.model+(p.bridge.cover?` — ${p.bridge.cover} cover`:"")]] ]);

  return h;
}
function buildSpecs(d){
  return specSections(d)+`<div class="rm-actions">
    <a class="rm-designer" href="${d.designer_url}" target="_blank" rel="noopener"><svg viewBox="0 0 24 24"><path d="M14 3h7v7M21 3l-9 9M21 14v5a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h5"/></svg>Open in 3D Designer</a>
    <button type="button" class="rm-designer ghost" data-dl="${d.id}"><svg viewBox="0 0 24 24"><path d="M12 3v13m0 0l-4.5-4.5M12 16l4.5-4.5M4 21h16"/></svg>Download spec sheet</button>
  </div>`;
}
function neckCard(d){
  const n=d.neck;
  const dims=[["Nut Width",n.nut_width],["Radius",n.radius_display],
    ["Scale",(n.scale_length||"").replace(/ -.*/,'')],
    ["Thickness",n.thickness_0?`${n.thickness_0} → ${n.thickness_12||''}`:""],["Frets",n.fret]]
   .filter(x=>x[1]).map(x=>`<div><span style="color:var(--rm-ink-faint)">${x[0]}:</span> <b>${x[1]}</b></div>`).join("");
  const src=n.svg?`${CDN}/necks/${encodeURIComponent(n.svg)}`:"";
  const svg=n.svg
    ? `<button class="rm-svgwrap" data-svg="${src}" title="Click to enlarge"><img src="${src}" alt=""><span class="rm-zoom">⤢</span></button>`
    : `<div class="rm-svgwrap none">Profile diagram<br>not catalogued</div>`;
  return `${svg}<div class="rm-nd"><div class="rm-lbl">Neck Profile</div><h4>${n.profile_label}</h4><div class="rm-dims">${dims}</div></div>`;
}

let vi=FRONT,imgs=[],spinT=null,token=null,prevBodyOverflowY="";
function setFrame(i){vi=((i%ANGLES.length)+ANGLES.length)%ANGLES.length;
  const im=imgs[vi];$("#rmFrame").src=(im&&im.complete)?im.src:framePath(token,ANGLES[vi]);
  $("#rmAngle").textContent=ANGLES[vi]+"°"}
function preload(t){token=t;imgs=ANGLES.map(a=>{const im=new Image();im.src=framePath(t,a);return im});
  const l=$("#rmLoader");l.classList.remove("hide");let done=0;
  imgs.forEach(im=>{const fin=()=>{if(++done>=ANGLES.length)l.classList.add("hide")};im.complete?fin():(im.onload=fin,im.onerror=fin)});
  setTimeout(()=>l.classList.add("hide"),2500);setFrame(FRONT)}
function stopSpin(){if(spinT){clearInterval(spinT);spinT=null;$("#rmSpinBtn").classList.remove("on")}}
$("#rmSpinBtn").onclick=()=>{if(spinT)stopSpin();else{$("#rmSpinBtn").classList.add("on");spinT=setInterval(()=>setFrame(vi+1),85)}};
$("#rmFrontBtn").onclick=()=>{stopSpin();setFrame(FRONT)};
(function(){const v=$("#rmViewer");let down=false,sx=0,si=0;
  const per=()=>Math.max(7,v.clientWidth/(ANGLES.length*1.4));
  v.addEventListener("pointerdown",e=>{down=true;sx=e.clientX;si=vi;v.classList.add("grab");v.setPointerCapture(e.pointerId);stopSpin()});
  v.addEventListener("pointermove",e=>{if(!down)return;const dx=e.clientX-sx;if(Math.abs(dx)>4)$("#rmHint").style.opacity=0;setFrame(si-Math.round(dx/per()))});
  const end=()=>{down=false;v.classList.remove("grab")};
  v.addEventListener("pointerup",end);v.addEventListener("pointercancel",end);
})();

function openModal(id){const d=DATA.find(x=>String(x.id)===String(id));if(!d)return;
  if(location.hash.replace('#','')!==String(id))location.hash=id;
  $("#rmMName").innerHTML=`<span style="color:var(--rm-beige)">${d.prefix} - </span>${d.name} <span class="rm-id">Design ${d.id}</span>`;
  $("#rmMBadges").innerHTML=`<span class="rm-coll">${icon(d.collection)}<span>${d.collection}</span></span><span class="rm-ser ${d.series.toLowerCase()}">${d.series} Electronics</span>`;
  $("#rmSpecs").innerHTML=buildSpecs(d);$("#rmSpecs").scrollTop=0;
  $("#rmNeckcard").innerHTML=neckCard(d);$("#rmHint").style.opacity=1;
  preload(d.token);
  if(!$("#rmModal").classList.contains("show")){prevBodyOverflowY=document.body.style.overflowY;document.body.style.overflowY="hidden"}
  $("#rmModal").classList.add("show")}
function closeModal(){if(!$("#rmModal").classList.contains("show"))return;
  stopSpin();$("#rmModal").classList.remove("show");document.body.style.overflowY=prevBodyOverflowY;
  if(location.hash)history.replaceState(null,"",location.pathname+location.search)}
function applyHash(){const id=location.hash.replace('#','');if(id&&DATA.some(d=>String(d.id)===id))openModal(id);}
window.addEventListener("hashchange",applyHash);
$("#rmModal").addEventListener("click",e=>{if(e.target.hasAttribute("data-close"))closeModal()});

const lb=$("#rmNecklb");
$("#rmNeckcard").addEventListener("click",e=>{const b=e.target.closest(".rm-svgwrap[data-svg]");
  if(b){$("#rmNecklbImg").src=b.dataset.svg;lb.classList.add("show")}});
lb.addEventListener("click",()=>lb.classList.remove("show"));

const SPEC_CSS=`*{margin:0;padding:0;box-sizing:border-box}
body{font-family:'Montserrat',Arial,sans-serif;background:#fff;color:#1a1a1a;padding:34px;max-width:760px;margin:0 auto;-webkit-font-smoothing:antialiased}
.sh-head{border-bottom:2px solid #CEA67D;padding-bottom:14px;margin-bottom:24px}
.sh-head .nm{font-size:27px;font-weight:800;letter-spacing:.01em}.sh-head .nm .px{color:#CEA67D}
.sh-head .sub{font-size:11px;letter-spacing:.16em;text-transform:uppercase;color:#8F6D50;font-weight:600;margin-top:7px}
.rm-sect{margin-bottom:24px}
.rm-sect .rm-hd h5{font-size:18px;font-weight:800;margin-bottom:10px}
.rm-sect .rm-hd .rm-ln{display:none}
.rm-rowgroup{display:flex;flex-direction:column;gap:9px}
.rm-rows{border:1px solid rgba(0,0,0,.1)}
.rm-row{display:grid;grid-template-columns:40% 60%}
.rm-row:not(:last-child){border-bottom:1px solid rgba(0,0,0,.06)}
.rm-row:nth-child(even){background:rgba(0,0,0,.02)}
.rm-row .rm-k{padding:9px 13px;font-size:12.5px;color:#6f6a63;border-right:1px solid rgba(0,0,0,.06)}
.rm-row .rm-v{padding:9px 13px;font-size:13.5px;font-weight:600}
.sh-foot{margin-top:28px;padding-top:12px;border-top:1px solid rgba(0,0,0,.08);font-size:10px;color:#a39c92;letter-spacing:.05em}
@media print{body{padding:6mm}}`;
function downloadSpec(id){
  const d=DATA.find(x=>String(x.id)===String(id));if(!d)return;
  const doc=`<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8">`+
    `<title>${d.prefix}-${d.name} — Shark Spec Sheet</title>`+
    `<link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800&display=swap" rel="stylesheet">`+
    `<style>${SPEC_CSS}</style></head><body>`+
    `<div class="sh-head"><div class="nm"><span class="px">${d.prefix} - </span>${d.name}</div>`+
    `<div class="sub">${d.collection} &middot; ${d.series} &middot; Design ${d.id}</div></div>`+
    specSections(d)+
    `<div class="sh-foot">Shark Guitars &middot; ${d.collection} &middot; specification generated from the Designer configuration.</div>`+
    `</body></html>`;
  const a=document.createElement("a");
  a.href=URL.createObjectURL(new Blob([doc],{type:"text/html"}));
  a.download=`${d.prefix}-${d.name}_${d.id}_spec.html`;
  document.body.appendChild(a);a.click();
  setTimeout(()=>{URL.revokeObjectURL(a.href);a.remove()},1500);
}
$("#rmSpecs").addEventListener("click",e=>{const b=e.target.closest("[data-dl]");if(b)downloadSpec(b.dataset.dl)});

document.addEventListener("keydown",e=>{
  if(e.key==="Escape"){if(lb.classList.contains("show"))lb.classList.remove("show");else closeModal();return}
  if($("#rmModal").classList.contains("show")){if(e.key==="ArrowRight"){stopSpin();setFrame(vi+1)}if(e.key==="ArrowLeft"){stopSpin();setFrame(vi-1)}}});

(function(){
  const nColl=new Set(DATA.map(d=>d.collection)).size;
  const nP=DATA.filter(d=>d.series==="Prime").length;
  const nS=DATA.filter(d=>d.series==="Supreme").length;
  $("#rmHeroStat").innerHTML=`${DATA.length} Guitars<span class="rm-sep">·</span>${nP} Prime <span class="rm-amp">&</span> ${nS} Supreme`;
  $("#rmHeroSub").textContent=`Across ${nColl} collections. Click any guitar to open its full specification; drag the guitar to rotate the 360° view.`;
})();
$("#rmFoot").textContent="Shark Guitars · Retail Models · specifications read directly from each Designer configuration.";
render();
applyHash();
})();
